"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BattleInfo = BattleInfo;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const models_1 = require("@creature-chess/models");
const getBattleText = (battle) => {
    if (!battle) {
        return "";
    }
    if (battle.status === models_1.PlayerBattleStatus.IN_PROGRESS) {
        return "Battling";
    }
    if (battle.status === models_1.PlayerBattleStatus.FINISHED) {
        return `${battle.homeScore} - ${battle.awayScore}`;
    }
    return "";
};
const getResultColor = (props) => {
    if (!props ||
        !props.battle ||
        props.battle.status !== models_1.PlayerBattleStatus.FINISHED) {
        return "#ffcd74";
    }
    const { isHomePlayer, homeScore, awayScore } = props.battle;
    const win = isHomePlayer ? homeScore > awayScore : awayScore > homeScore;
    return win ? "#38b764" : "#b13e53";
};
const useStyles = (0, react_jss_1.createUseStyles)({
    battleInfo: {
        padding: "0.25em 0.5em",
        fontSize: "0.625em",
        color: "#c3c3c3",
        textAlign: "center",
        background: "#333",
    },
    highlight: {
        fontWeight: 700,
        color: "#fff",
        textTransform: "uppercase",
    },
    result: (props) => ({ color: getResultColor(props) }),
});
function BattleInfo(props) {
    const classes = useStyles(props);
    const text = getBattleText(props.battle);
    if (!props.battle) {
        return null;
    }
    return (React.createElement("div", { className: classes.battleInfo },
        React.createElement("div", { className: (0, classnames_1.default)(classes.highlight, classes.result) }, text),
        React.createElement("div", null, "vs"),
        React.createElement("div", { className: classes.highlight },
            props.opponentName || "",
            props.battle.opponentIsClone && React.createElement(React.Fragment, null, "\u00A0(C)"))));
}
